import { BarChart3, ReceiptText, Users } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";

export function SaaSBillingPage() {
  return (
    <div className="page-stack">
      <section className="metric-grid metric-grid-four">
        <article className="metric-card">
          <Users size={20} />
          <span>Tenants</span>
          <strong>2</strong>
          <small>Pilotos</small>
        </article>
        <article className="metric-card">
          <BarChart3 size={20} />
          <span>Métricas faturáveis</span>
          <strong>8</strong>
          <small>Usuários, clientes, vidas, ativos...</small>
        </article>
        <article className="metric-card">
          <ReceiptText size={20} />
          <span>Período atual</span>
          <strong>ABERTO</strong>
          <small>Mensuração diária</small>
        </article>
        <article className="metric-card">
          <span>Lifecycle</span>
          <Badge tone="info">PILOT</Badge>
          <small>Trial → Onboarding → Pilot → Active</small>
        </article>
      </section>
      <Card title="Cobrança SaaS da Yatta" description="Plano base, módulos e consumo por tenant.">
        <div className="funnel-strip">
          <div>
            <strong>Base</strong>
            <span>Mensalidade</span>
          </div>
          <div>
            <strong>Usuários</strong>
            <span>Ativos</span>
          </div>
          <div>
            <strong>Clientes</strong>
            <span>Gerenciados</span>
          </div>
          <div>
            <strong>Recebíveis</strong>
            <span>Gerados</span>
          </div>
          <div>
            <strong>Documentos</strong>
            <span>Assinados</span>
          </div>
        </div>
        <div className="card-actions">
          <Button>Calcular período demo</Button>
        </div>
      </Card>
    </div>
  );
}
